export default "__VITE_ASSET__vboDEbRp__"